import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  createCouponCode,
  getCategoryList,
  getProductList,
  getProductTypeList,
  getCouponType,
} from "../adminSlice";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
// import { couponTypeList } from "../../../Utils/dataConstant";
import { isValidDiscount, validateDecimal } from "../../../Utils/validators";
import { discountValue, isValidDiscountErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const CreateCouponCode = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [couponTypeList, setCouponTypeList] = useState<any>([]);
  const [couponName, setCouponName] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [couponType, setCouponType] = useState<any>("");
  const [discPer, setDiscPer] = useState<any>("");

  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
    dispatch(
      getCouponType({
        callback: (res: any) => {
          setCouponTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCouponType = (value: any) => {
    setCouponType(value);
  };
  const onchangeDiscPer = (value: any) => {
    if (!isValidDiscount(value)) {
      return;
    }
    if (!validateDecimal(value)) {
      return;
    }
    if (value > 100) {
      return;
    }
    setDiscPer(value);
  };
  const onchangeProduct = (value: any) => {
    setProduct(value);
  };
  const onchangeCouponCode = (value: any) => {
    setCouponName(value);
  };
  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {
      name: couponName,
      couponType: couponType?.name,
      startDate: startDate,
      endDate: endDate,
    };
    if (discPer) {
      postData["discPer"] = discPer
    }
    if (productType?._id) {
      postData["productType"] = productType?._id
    }
    if (category?._id) {
      postData["categoryId"] = category?._id
    }
    if (product?._id) {
      postData["productId"] = product?._id
    }
    dispatch(
      createCouponCode({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setCouponName("");
            setStartDate(
              moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
            );
            setEndDate(
              moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
            );
            setCouponType("");
            setProductType("");
            setCategory("");
            setProduct("");
            setDiscPer("");
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    let valid = false;
    if (couponType?._id === 1) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "") {
        valid = true;
      }
    }
    if (couponType?._id === 2) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "") {
        valid = true;
      }
    }
    if (couponType?._id === 3) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "" || category === "") {
        valid = true;
      }
    }
    if (couponType?._id === 4) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "" || category === "" || product === "") {
        valid = true;
      }
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Coupon Code "} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Coupon Name"} isRequired />
                <InputField
                  placeholder={"Enter Coupon Name"}
                  setInputText={(value: any) => onchangeCouponCode(value)}
                  value={couponName}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Coupon Type"} isRequired />
                <DropdownWithClear
                  labelName={"Select Coupon Type"}
                  setInputText={(value: any) => onchangeCouponType(value)}
                  options={couponTypeList}
                  value={couponType}
                />
              </div>
              {couponType?._id === 4 ? (
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"Discount Percentage"} isRequired />
                  <InputField
                    placeholder={"Enter Discount Percentage"}
                    setInputText={(value: any) => onchangeDiscPer(value)}
                    value={discPer}
                  />
                </div>
              ) : null}
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DateTimePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DateTimePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              {(couponType?._id !== 1 || couponType?._id === 4) && (
                <>
                  <div className="col-md-4 mb-3">
                    <LabelInput labelName={"Product Type"} isRequired />
                    <DropdownWithClear
                      labelName={"Select Product Type"}
                      setInputText={(value: any) => onchangeProductType(value)}
                      options={productTypeList}
                      value={productType}
                      disabled={couponType?._id === 1}
                    />
                  </div>
                  {couponType?._id !== 2 && (
                    <>
                      <div className="col-md-4 mb-3">
                        <LabelInput labelName={"Category"} isRequired />
                        <DropdownWithClear
                          labelName={"Select Product category "}
                          setInputText={(value: any) => onchangeCategory(value)}
                          options={categoryList}
                          value={category}
                          disabled={couponType?._id === 1 || couponType?._id === 2}
                        />
                      </div>
                      {couponType?._id !== 3 && (
                        <div className="col-md-4 mb-3">
                          <LabelInput labelName={"Product List"} isRequired />
                          <DropdownWithClear
                            labelName={"Select Product List "}
                            setInputText={(value: any) => onchangeProduct(value)}
                            options={productList}
                            value={product}
                            disabled={
                              couponType?._id === 1 ||
                              couponType?._id === 2 ||
                              couponType?._id === 3
                            }
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              <div className="d-flex justify-content-center mt-3">
                <div className="col-md-3 pt-2">
                  <Submitbtn name={"Submit"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div >
    </div >
  );
};

export default CreateCouponCode;
